import { Box } from '@chakra-ui/react'
import React, { Fragment } from 'react'
import { useState } from 'react'
import { useEffect } from 'react'
import AllUserAccess from '../../component/AllUserAccess'
import axios from 'axios'
import { Auth } from '../../component/Auth'


function UserAll() {
  const [allUser,setAllUser] = useState([])
  const [render, setRender] = useState([])
  const [isLoading2, setIsLoading2] = useState({loading: true, error: false})
  useEffect(() => {
    let config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_RALCO_API_URL}/api/user-account/all-accounts`,
      headers: { 
        'Authorization': Auth()
    }
    };
    
    axios.request(config)
    .then((response) => {
      setAllUser(response.data.users);
      setIsLoading2({loading: false, error: false})
    })
    .catch((error) => {
      console.log(error);
      setAllUser(error.response.data.users);
      setIsLoading2({loading: false, error: true})
    });
  },[render])


  const renderData = () => {
    setRender((prev) => render + 1)
  }

  


  return (
    <Fragment>
      <Box p={5} flex="1" w={'100%'}>
       <AllUserAccess
          data={allUser || []}
          title={'All User Access'}
          head={["Name", "EMAIL ID", "CONTACT NO.", "ROLE", "ACCESS", "ACTION"]}
          accessDrop={[{id: 'ORDER_MANAGEMENT', title: 'Order Management'},{id: 'TENURE_MANAGEMENT', title: 'Tenure Management'}, {id: 'USER_MANAGEMENT', title: 'User Management'}, {id: 'SETTLEMENT_MANAGEMENT', title: 'Settlement Management'}, {id: 'RETURNS_MANAGEMENT' , title : 'Returns Management'},
          {id: 'CUSTOMER_MANAGEMENT', title: 'Customer Verification'},{id: 'NOTIFICATION_MANAGEMENT', title: 'Notification Management'}, {id: 'SETTINGS_MANAGEMENT', title: 'Settings'}, {id: 'DELIVERY_MANAGEMENT', title: 'Delivery Management'}, { id: 'DISPUTE_MANAGEMENT', title: 'Dispute Management'}, {id: 'INVENTORY_MANAGEMENT', title: 'Inventory Management'}]}
          renderData={renderData}
          isLoading2={isLoading2}
        />
        </Box>
    </Fragment>
  )
}

export default UserAll